<template>
  <v-container style="padding-top:3rem;padding-bottom: 5rem; min-height: 100vh;  height: inherit;overflow-y: auto;">
    <v-form ref="form" lazy-validation>
      <v-row justify="center">
        <v-col class="d-flex flex-column" cols="12" sm="6">
          <div class="text-h5 font-weight-bold primary--text">
            {{this.types}} 약관
            <!-- Certification number -->
          </div>
          <div class="desc-box text-subtitle-2">
            <div v-if="terms && types" v-html="terms[types]"></div>
          </div>

          <v-checkbox
            v-if="isFirst"
            v-model="service"
            :error-messages="error"
            :rules="[rules.service]"
            label="서비스 이용약관"
            @click="onService"
          ></v-checkbox>          

          <v-checkbox
            v-if="isFirst"
            v-model="finance"
            :error-messages="error"
            :rules="[rules.finance]"
            label="전자금융거래 이용약관"
            @click="onFinance"
          ></v-checkbox>           

          <!-- <v-select :items="psiteList" v-model="psite" required label="매장">
          </v-select> -->
        </v-col>
      </v-row>
      <!-- <v-row>
        <v-col cols="6">
          <v-btn
            class="font-weight-bold"
            tile
            fixed
            x-large
            style="width:50%;z-index: 5;left: 0;bottom: 0px;height: 56px;"
            to="/signin"
          >
            돌아가기
          </v-btn>
        </v-col>
        <v-col cols="6"> -->
          <!-- {{ this.refer_code }} -->
        <v-btn
          class="font-weight-bold"
          color="primary"
          x-large
          block
          @click="onSubmit"
          :disabled="loading"
        >
          확인
        </v-btn>

      <!-- </v-col>
      </v-row> -->
    </v-form>
 
    <v-dialog v-model="termsModal" persistent max-width="30rem">
          <v-card>
            <v-card-title   ></v-card-title>
            <v-card-text  >
              <div v-html="termsTxt" ></div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-0 primary" style ="">
              <v-btn
                color="#000000"
                
                
                width="100%"
                text
                x-large
                class="font-weight-bold"
                @click="termsModal = false"
              >
                확인
              </v-btn> 
               
            </v-card-actions>
          </v-card>
        </v-dialog> 

  </v-container>
</template>

<script>
export default {
  data: () => ({
    isFirst: false ,
    types:null , 
    token: '',
    recommend: '',
    psite: '',
    psiteList: [],
    termsTxt:null , 
    termsModal : false , 
    service:false, 
    finance:false, 
    terms : null , 
    

    rules: {
      required: (value) => !!value || '인증코드를 입력하세요.' , 
      service: (value) => !!value || '서비스 이용약관 확인하세요.' , 
      finance: (value) => !!value || '전자금융거래 이용약관 확인하세요.' 
    },
    error: ''
  }),
  computed: {
    loading() {
      return this.$store.getters.loading
    }
  },
  methods: {
    onService(){
      
      if( this.service ==  true ) {
        this.termsModal = true ;         
        this.termsTxt = this.terms.service ; 
      }
    } ,     
    onFinance(){
      
      if( this.finance ==  true ) {
        this.termsModal = true ;         
        this.termsTxt = this.terms.finance ; 
      }
    } , 

    onSubmit() {
      const isLoggedIn = this.$store.state.acessToken && this.$store.state.user

      // 로그인 정보가 있으면 메인, 없으면 로그인 페이지로 이동
      if (isLoggedIn) {
        this.$router.push('/home')
      } else {
        this.$router.push('/signin')
      }
    }
  },
  // beforeRouteEnter(to, from, next) {
  //   // type 값이 없거나 허용되지 않은 값이면 /agree/finance로 리다이렉트
  //   const allowedTypes = ['service', 'finance']
  //   const type = to.params.type
    
  //   if (!type || !allowedTypes.includes(type)) {
  //     next({ path: '/agree/finance', replace: true })
  //   } else {
  //     next()
  //   }
  // },
  beforeRouteUpdate(to, from, next) {
    // 경로가 업데이트될 때도 검증
    const allowedTypes = ['service', 'finance', 'privacy']
    const type = to.params.type
    
    if (!type || !allowedTypes.includes(type)) {
      next({ path: '/agree/finance', replace: true })
    } else {
      this.types = type
      next()
    }
  },
  created() {
    // agree/:type 라우트 파라미터 검증
    const allowedTypes = ['service', 'finance', 'privacy']
    const type = this.$route.params.type
    
    if (!type || !allowedTypes.includes(type)) {
      this.$router.push('/agree/finance')
      return
    }
    
    // types에 저장
    this.types = type

    this.$store
      .dispatch('psite')
      .then((res) => {
        // console.log(res)
        if (res.data.result) {

          this.terms = res.data.terms  ;
          const data = res.data.data ; 
          

          this.psiteList = Object.keys(data).map((item) => ({
            text: data[item],
            value: item
          }))
        } else throw res
      })
      .catch((err) => {
        this.error = '인터넷 연결이 불안정합니다. 잠시후 다시 시도해주세요.'
      })

    // if (!this.$route.params.phone) this.$router.replace('/signin')
    
    // const psite = this.$cookies.get('psite')
    // if (psite) this.psite = psite
    // const recommend = this.$cookies.get('recommend')
    // if (recommend) this.recommend = recommend ; 


    // if( this.$route.params.firstLogin == true)  {
    //   this.isFirst = true  
    // } else{ 
    //   this.finance = true ; 
    //   this.service = true ;    
    // } ;

    // this.refer_code =  this.$cookies.get('refer_code')  ;     
    // console.log("refer_code ::?? "  ,  this.$cookies.get('refer_code') )
  }
}
</script>

<style>
.desc-box {
  background-color: #f1f1f1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 2rem;
  margin: 1rem auto;
  width: 60%;
  max-width: 60%;
  box-sizing: border-box;
  max-height: 50vh;
  overflow-y: auto;
  word-break: break-word;
}

@media (max-width: 960px) {
  .desc-box {
    width: 90%;
    max-width: 90%;
    max-height: 60vh;
  }
}
</style>
